// 合同详情「全部业务」独立 JS 模块
// 把合同详情页的所有数据、计算属性、方法、生命周期集中到这里，
// contractDetail.vue 与 client.vue 内嵌的合同详情共用同一份逻辑，避免重复。
import {
  getOrdersDetailData,
  getClientOrderDetailData,
  saveOrdersData,
  getContractRoomFormOptionsData,
  //【P33】桌型/增值服务下拉需按数据库 id 取值（与老系统二维口径一致），
  //  故直接复用 H5 会议室订单页的表单接口，避免中文名硬编码。
  getRoomOrderFormData,
  saveContractRoomOrderDeleteData,
  uploadPaymentImage,
  getContractRoomOrderListData,
  getFinanceStaffListData,
  getFinanceContractOptionsData,
  getRefundTransferOptionsData
} from "../api/api.js";
import { suppressGlobalError } from "../util/request.js";
import { getStaff } from "@/api/staff.js";
// 9 个业务单据页面配置已拆分到独立 JS 文件（每个页面一个文件），在此统一聚合引入
import { billConfigs } from "../pages/contract/index.js";

export default {
  data() {
    return {
      // sn 由 props.contractSn 或路由参数注入（见 created）
      sn: "",
      loaded: false,
      activeTab: 0,
      contract: {},
      detail: {},

      // 9 个实体 tab 配置（驱动列表 + 添加表单）
      // 9 个业务单据页面配置：来自 src/pages/contract/*.js（每页一个独立文件）
      tabConfigs: billConfigs,

      lists: {},

      // 整页表单模式：null=列表页 / "add"=新增表单 / "edit"=编辑表单
      billFormMode: null,
      activeAddTab: {},
      addForm: {},
      saving: false,

      // 下拉选择（ActionSheet）
      sheetVisible: false,
      sheetTitle: "",
      sheetTarget: "",
      sheetOptions: [],
      // 选中下拉后联动回填：{ 目标字段: 选项对象上的键 }
      sheetFill: null,

      // 日期选择：datePlanIndex >= 0 表示正在选回款计划第 N 行的日期
      dateVisible: false,
      dateCurrent: new Date(),
      dateTarget: "",
      //【P33】使用时间滑动选择器状态
      timeVisible: false,
      timeCurrent: "08:30",
      timeTarget: "",
      timeTargetWhich: "begin",
      datePlanIndex: -1,
      minDate: new Date(2015, 0, 1),

      // 编辑弹层
      editVisible: false,
      editForm: {},

      // 会议室全量缓存（含 store_sn / prices），用于「门店→会议室」联动过滤
      roomOptionsAll: [],

      // 商机全量缓存（含 customer_sn），用于「客户→商机」二级联动过滤
      opportunityOptionsAll: [],

      // 编辑态：当前正在编辑的预订单 sn（为空表示新增）
      editingSn: "",

      // 删除确认弹窗状态
      showDel: false,
      delRow: null,

      // 保存按钮调试信息（用于排查点击无反应；仅在 ?debug=1 时展示）
      saveDebug: "",

      // 06 当前登录人 staff id（支付单「受理人」默认值）
      currentStaffId: ""
    };
  },

  computed: {
    statusTagType() {
      const map = { 0: "warning", 1: "success", 2: "danger" };
      return map[this.contract.status] || "default";
    },
    hasInfoData() {
      const c = this.contract || {};
      const d = this.detail || {};
      const basic = c.name || c.serial_number || c.customer_name || c.opportunitie_text || c.sales_amount || c.room_amount || c.signing_date || c.start_date || c.end_date || c.contacts || c.phone || c.weixin || c.remark;
      const lists = (d.contacts && d.contacts.length) || (d.orders_meeting_room && d.orders_meeting_room.length) || (d.added_services && d.added_services.length);
      return !!(basic || lists);
    },

    // 添加表单按 group 分区（无 group 的字段统一归入「信息」；hidden / plans 不参与渲染）
    addGroups() {
      const fields = (this.activeAddTab && this.activeAddTab.fields) || [];
      const map = {};
      const order = [];
      fields.forEach(f => {
        // 【P17】label 类型为服务端挂载的展示字段（如回款计划关联对象），不进表单
        if (f.type === "hidden" || f.type === "label") return;
        const g = f.group || "信息";
        if (!map[g]) { map[g] = { name: g, fields: [] }; order.push(g); }
        map[g].fields.push(f);
      });
      return order.map(k => map[k]);
    },

    // 折扣率：销售价格 / 市场价格 × 10（自动计算，只读展示）
    discountText() {
      const p = Number(this.addForm.price);
      const a = Number(this.addForm.amount);
      if (!p || !a || isNaN(p) || isNaN(a)) return "";
      return (a / p * 10).toFixed(2);
    },

    // 【P12/P13】当前表单是否为流程单据（支付单/退款单：footer 双按钮 存草稿/提交审批）
    isPaymentForm() {
      return !!(this.activeAddTab && (this.activeAddTab.key === "payment" || this.activeAddTab.key === "refund"));
    }
  },

  created() {
    // 优先用 props.contractSn（内嵌场景），其次用路由参数（独立路由场景）
    this.sn = (this.contractSn && this.contractSn !== "")
      ? this.contractSn
      : (this.$route && this.$route.params && this.$route.params.sn ? this.$route.params.sn : "");
    this.fetchHeader();
    this.fetchDetail();
    this.loadAllLists();
    this.loadRoomFormOptions();
    this.loadPaymentFormOptions();
    this.fetchCurrentStaff();
  },

  methods: {
    /**
     * 全站统一提示（02）：优先用页面内的 <CrmNotice ref="notice">，
     * 无该组件时退回 Vant $toast 兜底，保证任何调用点都不会静默丢提示。
     * @param {String} msg  提示文案（失败时请传后端 res.msg 原文）
     * @param {String} type success | error | warning | info
     */
    notice(msg, type) {
      if (!msg) return;
      const n = this.$refs && this.$refs.notice;
      if (n && typeof n.show === "function") {
        n.show(msg, type || "success");
        return;
      }
      if (typeof this.$toast === "function") {
        this.$toast(msg);
      } else {
        console.log("[notice]", msg);
      }
    },

    /**
     * 06 当前登录人：支付单「受理人」默认取当前登录人 staff id。
     * 失败静默（受理人非必填，业务上允许留空由后端取登录人兜底）。
     */
    fetchCurrentStaff() {
      getStaff({}).then(res => {
        if (res && res.code == 200 && res.data) {
          this.currentStaffId = res.data.id || "";
        }
      }).catch(() => {});
    },

    fmtMoney(v) {
      if (v === undefined || v === null || v === "") return "0.00";
      return Number(v).toFixed(2);
    },

    // 返回：内嵌场景由父组件监听 @back 关闭遮罩（不再路由跳转）；独立路由场景回退
    goBack() {
      this.$emit("back");
      if (!this.$listeners || !this.$listeners.back) {
        if (window.history.length > 1) {
          this.$router.back();
        } else {
          this.$router.push("/client");
        }
      }
    },

    /* 合同主数据（含 contract.approval —— 审批区的状态就来自这里）。
       【P154】改为返回 Promise：总览/单据页下拉刷新与审批完成后都要 await/收口它，
       否则审批区状态会一直停在「待审批」（下拉刷新看着「没反应」）。 */
    fetchHeader() {
      if (!this.sn) return Promise.resolve();
      return getOrdersDetailData({ sn: this.sn }).then(res => {
        if (res && res.code == 200) {
          this.contract = Object.assign({}, this.contract, res.data || {});
        } else {
          // 合同详情页后台返回非 200（如 400/500）时，避免返回列表后仍残留红色全局 Message
          suppressGlobalError();
        }
      }).catch(e => {
        suppressGlobalError();
        console.log(e);
      });
    },

    fetchDetail() {
      if (!this.sn) return Promise.resolve();
      // 【P24-1】返回 Promise，使总览区下拉刷新能等待详情真正返回后再收起动画
      return getClientOrderDetailData({ sn: this.sn }).then(res => {
        if (res && res.code == 200) {
          this.detail = res.data || {};
          // 资料 tab 用到的嵌套字段兜底
          if (!this.detail.contacts) this.detail.contacts = [];
          if (!this.detail.orders_meeting_room) this.detail.orders_meeting_room = [];
          if (!this.detail.added_services) this.detail.added_services = [];
          this.loaded = true;
        } else {
          // 不弹全局错误提示，避免返回列表后仍有红色 Message 残留
          suppressGlobalError();
          this.loaded = true;
        }
      }).catch(e => {
        suppressGlobalError();
        console.log(e);
        this.loaded = true;
      });
    },

    // 单据列表：后端忽略 page/pageSize，固定一次返回全量（实测 pageSize=5 仍回 44 条），
    // 因此这里只发一次请求，不要再自行翻页拼页，否则会重复追加同一批数据。
    // 返回 Promise.all，便于下拉刷新等待全部完成。
    loadAllLists() {
      const tasks = this.tabConfigs.map(tab => {
        this.$set(this.lists, tab.key, []);
        if (typeof tab.listFn !== "function") return Promise.resolve();
        return tab
          .listFn({ sn: this.sn, page: 1, pageSize: 100 })
          .then(res => {
            if (res && res.code == 200 && res.data) {
              const arr = res.data.data || res.data.list || res.data || [];
              this.$set(this.lists, tab.key, Array.isArray(arr) ? arr : []);
            } else {
              // 9 个业务单据列表任一接口返回非 200 时，不要弹红色全局 Message，
              // 避免从合同详情返回列表后仍有错误提示残留
              suppressGlobalError();
            }
          })
          .catch(e => {
            suppressGlobalError();
            console.log(e);
          });
      });
      return Promise.all(tasks);
    },

    // 【P24-5/7】按单据重拉单个列表（带筛选参数）。支付单等需要服务端筛选的单据走这里；
    // 不传 extra 时等价于 loadAllLists 中该单据的那一次请求。
    reloadBillList(tab, extra) {
      const t = tab || this.billTab;
      if (!t || typeof t.listFn !== "function") return Promise.resolve();
      const params = Object.assign({ sn: this.sn, page: 1, pageSize: 100 }, extra || {});
      return t.listFn(params).then(res => {
        if (res && res.code == 200 && res.data) {
          const arr = res.data.data || res.data.list || res.data || [];
          this.$set(this.lists, t.key, Array.isArray(arr) ? arr : []);
        } else {
          suppressGlobalError();
        }
      }).catch(e => { suppressGlobalError(); console.log(e); });
    },

    // 卡片标题：优先用单据配置声明的 titleFields（可组合成「名称 · 金额 / 日期 · 金额」）。
    // 旧的「取第一个有值字段」会让同类型卡片标题雷同（回款计划 44 条全是状态名、审批 14 条全是「驳回」），无法区分。
    rowTitle(tab, row) {
      const keys = tab.titleFields || [];
      if (keys.length) {
        const parts = [];
        for (const k of keys) {
          let s = this.rowText(row, k, k + "_name");
          if (s === "" || s === null || s === undefined) continue;
          const f = (tab.fields || []).find(x => x.prop === k);
          const isMoney = (f && (f.type === "number" || f.type === "currency")) || /amount|price/.test(k);
          let text;
          if (isMoney) {
            const n = Number(s);
            text = isNaN(n) ? "¥" + s : "¥" + this.fmtMoney(n);
          } else {
            text = String(s);
          }
          // 同一取值只出现一次（如会议室 name 与 meeting_room_name 相同 → 不再重复拼一次）
          if (parts.indexOf(text) >= 0) continue;
          parts.push(text);
          if (parts.length >= 2) break;
        }
        if (parts.length) return parts.join(" · ");
      }
      // 兜底：取第一个有「名称」的字段作为卡片标题（优先 *_name / nameKey 映射列，跳过隐藏/计划/折扣）
      let fallback = tab.title + "记录";
      for (let f of tab.fields) {
        if (f.type === "hidden" || f.type === "plans" || f.type === "discount") continue;
        const nk = f.nameKey || (f.prop + "_name");
        const nv = row[nk];
        if (nv !== undefined && nv !== "" && nv !== null) return nv;
        const v = row[f.prop];
        if (v !== undefined && v !== "" && v !== null) fallback = v;
      }
      return fallback;
    },

    // 卡片行显示：有 nameKey / *_name 名称字段时优先展示名称（避免直接暴露 sn）
    rowText(row, prop, nameKey) {
      const nk = nameKey || (prop + "_name");
      const nv = row[nk];
      if (nv !== undefined && nv !== "" && nv !== null) return nv;
      const v = row[prop];
      return (v === undefined || v === null) ? "" : v;
    },

    // 【P13】老系统 order_meeting_room JSON 解码（对齐 ContractCreateService::decodeMeetingRoomIds）：
    // 支持 [[id],...] / [id,...]（平铺）/ "id,id"（H5 旧逗号数据兼容），返回 id 数组
    parseMeetingRoomIds(raw) {
      if (raw === undefined || raw === null || raw === "") return [];
      let arr = raw;
      if (typeof raw === "string") {
        const s = raw.trim();
        if (s.indexOf("[") === 0) {
          try { arr = JSON.parse(s); } catch (e) { return s.split(",").map(x => x.trim()).filter(Boolean); }
        } else {
          return s.split(",").map(x => x.trim()).filter(Boolean);
        }
      }
      if (!Array.isArray(arr)) return [];
      const ids = [];
      arr.forEach(v => {
        if (Array.isArray(v) && v.length && v[0] !== undefined && v[0] !== null) ids.push(v[0]);
        else if (typeof v === "number" || /^\d+$/.test(String(v))) ids.push(v);
      });
      return ids;
    },

    // 【P13-fix】关联字段反解：按字段 options 把 value（sn / id / 编码）解析成 label；
    // order_meeting_room 为老系统 JSON [[id],...] 先解码；其余 multiselect 逗号串逐段解析。
    // 全部未命中返回 ""（调用方保留原值），部分命中未命中段保留原值。
    refLabel(f, value) {
      if (value === "" || value === null || value === undefined) return "";
      const opts = (f && f.options) || [];
      if (!opts.length) return "";
      let parts;
      if (f.prop === "order_meeting_room") {
        parts = this.parseMeetingRoomIds(value);
      } else {
        parts = String(value).split(",").map(s => s.trim()).filter(Boolean);
      }
      if (!parts.length) return "";
      let resolved = 0;
      const labels = parts.map(p => {
        const hit = opts.find(o => String(o.value) === String(p));
        if (hit) { resolved++; return hit.label; }
        return p;
      });
      if (!resolved) return "";
      return labels.join("、");
    },

    // 【P13-fix】单据字段展示统一入口：_name 优先（rowText），否则按 options 反解 sn/id/编码为名称
    rowDisp(tab, f, row) {
      let v = this.rowText(row, f.prop, f.nameKey);
      if (v === "" || v === null || v === undefined) return v;
      /* 【P227 修复】chips / multiselect 多值字段（桌型 table_types、增值服务 option_service）
         落库是二维 id 数组 JSON（如 "[[248],[249]]"），refLabel 按单值反解必然命中不了
         ⇒ 详情里直接把这串 JSON 原文显示出来。
         这里统一走 normChipValues 归一为 id 数组，再用 f.options 映射成中文 label，
         以「、」连接。options 未就绪时退回原值（不空白、便于排查）。 */
      if (f.type === "chips" || f.type === "multiselect") {
        const ids = this.normChipValues(v, f.options || []);
        if (ids.length) {
          const map = {};
          (f.options || []).forEach(o => { map[String(o.value)] = o.label; });
          const names = ids
            .map(id => (map[String(id)] !== undefined ? map[String(id)] : ""))
            .filter(x => x !== "");
          if (names.length) return names.join("、");
        }
        return v;
      }
      const rl = this.refLabel(f, v);
      return rl || v;
    },

    // ===== 统一单据列表（9 个单据页共用一套行结构与样式）=====

    // 金额：1200 → ¥1,200.00；空值返回空串
    billMoney(v) {
      if (v === undefined || v === null || v === "") return "";
      const n = Number(v);
      if (isNaN(n)) return String(v);
      const p = n.toFixed(2).split(".");
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return "¥" + p.join(".");
    },

    // 04 宫格角标：该单据页「驳回类」条数（驳回 / 未通过 / 拒绝）；用于红色气泡仅在驳回时显示
    // 【P10】优先取审批状态名（支付单列表 P10 起返回 approval_status_name），驳回时红点生效
    tabRejectCount(tab) {
      const rows = (this.lists && tab && this.lists[tab.key]) || [];
      return rows.filter(r => /驳回|未通过|拒绝/.test(String(r.approval_status_name || r.status_name || ""))).length;
    },

    // 【P12/P13】行级编辑门禁：支付单/退款单 仅 驳回(2)/待提交(3) 可编辑；审核中(0)/已生效(1) 隐藏编辑
    rowEditable(row) {
      if (!row) return true;
      /* 【P95-B4 四.1.005】后端 BillListService::rowPerms() 已按「归属 ∪ 状态」下发行级权限，
         前端优先采用（缺省时回退到下面的本地状态机，保持老行为不变）。 */
      if (row.can_edit !== undefined && row.can_edit !== null && row.can_edit !== "") {
        return Number(row.can_edit) === 1;
      }
      const tab = this.billTab;
      if (tab && (tab.key === "payment" || tab.key === "refund")) {
        const stNow = Number(row.status);
        return stNow === 2 || stNow === 3;
      }
      return true;
    },

    // 【P12/P13】行级删除门禁：支付单/退款单 审核通过(1) 锁死不可删（后端同门禁拦截）
    rowDeletable(row) {
      if (!row) return true;
      /* 【P95-B4 四.1.005】同上：优先用后端下发的 can_delete */
      if (row.can_delete !== undefined && row.can_delete !== null && row.can_delete !== "") {
        return Number(row.can_delete) === 1;
      }
      const tab = this.billTab;
      if (tab && (tab.key === "payment" || tab.key === "refund")) return Number(row.status) !== 1;
      return true;
    },

    // 【P12/P13】行级「提交」按钮：仅待提交(3) 的支付单/退款单显示
    canSubmitRow(row) {
      if (!row) return false;
      const tab = this.billTab;
      if (tab && (tab.key === "payment" || tab.key === "refund")) return Number(row.status) === 3;
      return false;
    },

    // 【P12】列表行内提交审批：最小 payload 走编辑接口 action=submit（后端 CC7 重提审批）
    submitRow(row) {
      if (!row || !row.sn) return;
      const tab = this.billTab;
      if (!tab || typeof tab.editFn !== "function") {
        this.notice("提交入口未配置，请联系管理员", "error");
        return;
      }
      this.saving = true;
      tab.editFn({ sn: row.sn, order_sn: row.sn, action: "submit" }).then(res => {
        this.saving = false;
        if (res && res.code == 200) {
          this.notice(res.msg || "已提交审批", "success");
          this.loadAllLists();
        } else {
          this.notice((res && res.msg) || "提交失败", "error");
        }
      }).catch(e => {
        this.saving = false;
        this.notice((e && e.msg) || "提交失败（网络/接口异常）", "error");
      });
    },

    // 按字段命名自动推导「金额 / 单号 / 日期 / 状态」，剩余字段作为详情网格
    billMeta(tab, row) {
      const fs = tab.fields || [];
      const pick = fn => {
        const f = fs.find(fn);
        return f && f.prop ? f.prop : "";
      };
      const amount = pick(f => /amount$/.test(f.prop));
      const date = pick(f => f.type === "date" || /_date$/.test(f.prop) || /_time$/.test(f.prop));
      const no = pick(f => /_no$/.test(f.prop)) || "serial_number";
      // 状态：接口统一落在 status_name（审批配置里写的 approval_status 实际返回的也是 status_name）
      let status = row.status_name;
      if (status === undefined || status === null) status = "";
      const skip = {};
      if (amount) skip[amount] = 1;
      if (date) skip[date] = 1;
      if (no) skip[no] = 1;
      skip["status_name"] = 1;
      skip["approval_status"] = 1;
      // 原始 sn（32 位十六进制）不直接展示，避免出现一长串无意义字符
      const isRawSn = v => typeof v === "string" && /^[0-9a-f]{32}$/i.test(v);
      const details = fs.filter(f => {
        if (!f || !f.prop || skip[f.prop]) return false;
        if (f.type === "hidden" || f.type === "plans" || f.type === "discount") return false;
        // 【P13-fix】走 rowDisp：sn/id/编码按 options 反解成名称后再判断（反解成功的中文不再被 isRawSn 过滤）
        const v = this.rowDisp(tab, f, row);
        if (v === "" || v === null || v === undefined) return false;
        return !isRawSn(v);
      });
      let dateText = date ? String(this.rowText(row, date) || "") : "";
      // 单据没有日期字段时，用创建时间兜底（退款单/余额明细/审批等）
      if (!dateText && row.create_time) dateText = String(row.create_time).slice(0, 10);
      let sum = 0;
      let hasSum = false;
      if (amount) {
        const n = Number(row[amount]);
        if (!isNaN(n)) { sum = n; hasSum = true; }
      }
      return {
        amountNum: hasSum ? sum : null,
        amountText: amount ? this.billMoney(row[amount]) : "",
        noText: no ? String(this.rowText(row, no) || "") : "",
        dateText: dateText,
        status: String(status),
        details: details
      };
    },

    // 状态标签配色：复用主列表（客户/商机/合同）同一套 status-tag
    //   tag-receive 绿=完成 / tag-danger 红=异常 / tag-allot 蓝=进行中 / tag-wait 橙=待处理
    billStatusClass(s) {
      const t = String(s || "");
      if (/已退款|驳回|作废|未通过|失败|已取消/.test(t)) return "tag-danger";
      if (/已支付|已回款|已开票|通过|生效|已完成|已全款|已入账|已扣减/.test(t)) return "tag-receive";
      /* 【P108】审核相关态一律黄色（用户口径：列表中「审核中」用黄色）
         —— 会议室订单 status_name=审核中、审批单 status_name=等待审核，两者同色系 */
      if (/审核中|等待审核|待审批|待审核/.test(t)) return "tag-wait";
      if (/部分|进行中|审核中/.test(t)) return "tag-allot";
      return "tag-wait";
    },

    openAdd(tab) {
      this.activeAddTab = tab;
      this.saveDebug = "";
      // 按字段类型初始化默认值（chips→数组，range→{begin,end}，plans→两行空计划）
      const form = { sn: this.sn };
      (tab.fields || []).forEach(f => {
        if (f.type === "chips" || f.type === "multiselect") form[f.prop] = [];
        else if (f.type === "range") form[f.prop] = { begin: "", end: "" };
        else if (f.type === "plans") form[f.prop] = [{ date: "", amount: "" }];
        else form[f.prop] = "";
      });
      // 合同默认取当前合同（【P12/P13】支付单/退款单除外：contracts_sn 语义是财务合同 sn，不可预填销售合同 sn）
      if (form.contracts_sn !== undefined && !form.contracts_sn && tab.key !== "payment" && tab.key !== "refund") form.contracts_sn = this.sn;
      // 05 合同 -> 客户 / 商机 自动带出：所有单据通用（原来只对支付单生效）
      // 后端 _contractTabRoomOrderBuild 等也有同源兜底，前端先带出可减少一次报错往返
      if (form.customer_sn !== undefined && !form.customer_sn) {
        form.customer_sn = (this.contract && this.contract.customer_sn) || "";
      }
      if (form.opportunitie_sn !== undefined && !form.opportunitie_sn) {
        form.opportunitie_sn = (this.contract && this.contract.opportunitie_sn) || "";
      }
      // 06 受理人：默认当前登录人（可改）
      if (form.owner_id !== undefined && !form.owner_id && this.currentStaffId) {
        form.owner_id = this.currentStaffId;
      }
      // 上传类字段：初始化预览列表
      (tab.fields || []).forEach(f => {
        if (f.type === "upload") this.$set(form, f.prop + "_list", []);
      });
      // 【P14】会议室订单 is_free 默认「否（收费）」
      if (form.is_free !== undefined && (form.is_free === "" || form.is_free === undefined || form.is_free === null)) {
        form.is_free = 1;
      }
      // 【P33】会议室订单「使用时间」默认 08:30 ~ 20:30
      //   对齐老系统 CRMMetingRoomOrders 表单默认值（"field"=>"start_time","value"=>["08:30","20:30"]）
      if (tab.key === "room" && form.start_time !== undefined) {
        const _stDef = form.start_time || {};
        if (!_stDef.begin && !_stDef.end) {
          form.start_time = { begin: "08:30", end: "20:30" };
        }
      }
      this.addForm = form;
      // 进入新增：清空编辑态
      this.editingSn = "";
      // 首次进入弹层：按当前门店过滤会议室（默认无门店→全量），按客户过滤商机（默认无客户→全量）
      this.applyRoomStoreFilter();
      this.applyCustomerOppFilter();
      /* 【P215】支付单：按合同类型收敛支付方式 / 合同类型选项 */
      if (tab.key === "payment") { this.applyPaymentProductLimit(); }
      /* 【P218】财务发票：自动关联客户 / 销售合同 / 所属财务合同下拉 */
      if (tab.key === "invoice") { this.applyInvoiceAutoFill(tab); }
      // 【P214】每次打开新增表单都重拉「关联会议室订单」选项，
      // 否则新建的会议室订单不会出现在选项里（必须刷新浏览器才可见）。
      this.loadMeetingRoomOrderOptions();
      // 升级：详情/新增页改为「整页表单」（不再用底部弹层），由 contractDetail.vue 渲染
      this.billFormMode = "add";
    },

    // 编辑某条单据：按当前单据页回填（会议室预订单走专属回填，其余单据用 fields 通用回填）
    openEdit(row) {
      // 【P10-3 修复】原先硬编码取会议室页导致支付单点「编辑」打开会议室订单表单；改为优先当前单据页
      const cur = this.billTab;
      const tab = cur || (this.tabConfigs || []).find(t => t.key === "room");
      if (!tab) return;
      // 【P12/P13】支付单/退款单仅 驳回(2)/待提交(3) 可编辑；审核中(0)/已生效(1) 拦截
      if (cur && (cur.key === "payment" || cur.key === "refund") && row) {
        const stNow = Number(row.status);
        if (stNow !== 2 && stNow !== 3) {
          const billName = cur.key === "refund" ? "退款单" : "支付单";
          const lockedMsg = cur.key === "refund" ? "已退款的退款单不可编辑" : "审核通过的支付单不可编辑";
          this.notice(stNow === 0 ? "审核中的" + billName + "暂不可编辑，可删除" : lockedMsg, "warning");
          return;
        }
      }
      // 非会议室单据：按 fields 直接回填（row 里的值优先，取不到再用 *_name）
      if (tab.key !== "room") {
        this.activeAddTab = tab;
        this.saveDebug = "";
        this.editingSn = row.sn || "";
        const form = { sn: this.sn };
        (tab.fields || []).forEach(f => {
          if (f.type === "chips" || f.type === "multiselect") form[f.prop] = [];
          else if (f.type === "range") form[f.prop] = { begin: "", end: "" };
          else if (f.type === "plans") form[f.prop] = [{ date: "", amount: "" }];
          else form[f.prop] = "";
        });
        (tab.fields || []).forEach(f => {
          if (f.type === "chips" || f.type === "range" || f.type === "plans") return;
          const v = row[f.prop];
          form[f.prop] = (v === undefined || v === null) ? "" : v;
        });
        // 【P9】multiselect 编辑回填：后端逗号串 → 数组；并按已选合同类型拉财务合同选项
        // 【P13】order_meeting_room 是老系统 JSON [[id],...] → 走 parseMeetingRoomIds 解码成 id 数组
        (tab.fields || []).forEach(f => {
          if (f.type !== "multiselect") return;
          const raw = row[f.prop];
          if (f.prop === "order_meeting_room") {
            form[f.prop] = this.parseMeetingRoomIds(raw);
          } else {
            form[f.prop] = raw ? String(raw).split(",").filter(Boolean) : [];
          }
        });
        if (Number(form.payment_product) >= 1) {
          this.loadFinanceContractOptions(Number(form.payment_product));
        }
        // 上传类字段：编辑态回填预览列表
        (tab.fields || []).forEach(f => {
          if (f.type === "upload") {
            const v = row[f.prop];
            this.$set(form, f.prop + "_list", (v && String(v).indexOf("http") === 0) ? [{ url: v, isImage: true }] : []);
          }
        });
        this.addForm = form;
        this.billFormMode = "edit";
        return;
      }
      this.activeAddTab = tab;
      this.saveDebug = "";
      this.editingSn = row.sn || "";
      const form = { sn: this.sn };
      (tab.fields || []).forEach(f => {
        if (f.type === "chips") form[f.prop] = [];
        else if (f.type === "range") form[f.prop] = { begin: "", end: "" };
        else if (f.type === "plans") form[f.prop] = [{ date: "", amount: "" }];
        else form[f.prop] = "";
      });
      // 基础字段回填
      /* 【P107】会议室预订单的「合同」字段语义 = **销售合同**。
         历史字段名 contracts_sn 有歧义：表列 pro_orders_meeting_room.contracts_sn 实际存的是**财务合同**，
         而后端入参 contracts_sn 被当作销售合同用于 parent_sn。
         原实现 `row.contracts_sn || this.sn` 会把**财务合同 sn** 提交上去 →
         ① parent_sn 被写坏（会议室订单从销售合同下消失）② 重新送审按财务合同查 join 查不到、审批单不生成。
         这里对会议室预订单固定回填当前销售合同 sn（该字段本就 readonly、口径为「当前合同」）。 */
      form.contracts_sn = (tab.key === "room") ? this.sn : (row.contracts_sn || this.sn);
      form.customer_sn = row.customer_sn || "";
      form.opportunitie_sn = row.opportunitie_sn || "";
      form.stores_sn = row.stores_sn || "";
      form.meeting_room_sn = row.meeting_room_sn || "";
      form.meeting_room_name = row.meeting_room_name || "";
      form.meeting_room_room_number = row.meeting_room_room_number || "";
      form.on_site_time = row.on_site_time || "";
      form.time_type_name = (row.time_type !== "" && row.time_type !== null && row.time_type !== undefined) ? Number(row.time_type) : "";
      //【P33 修复】使用时间：原实现只在含 "~" 时回填，JSON 数组（老系统与修复后新数据）
      //  会落到 else 分支变成空白，保存时反把使用时间清空。改为统一归一。
      form.start_time = this.normTimeRange(row.start_time);
      form.number_people = (row.number_people !== undefined && row.number_people !== null) ? row.number_people : "";
      form.price = (row.price !== undefined && row.price !== null) ? row.price : "";
      form.amount = (row.amount !== undefined && row.amount !== null) ? row.amount : "";
      //【P33 修复】桌型/增值服务：原实现 String(x).split(",") 无法解析 JSON 二维
      //  （'[[248],[249]]' → ['[[248]', '[249]]'] 乱码），导致芯片全部不亮。改为统一归一，
      //  并按当前 options 把中文名（历史脏数据）映射回 id。
      const _ttField = (tab.fields || []).find(x => x.prop === "table_types");
      const _osField = (tab.fields || []).find(x => x.prop === "option_service");
      form.table_types = this.normChipValues(row.table_types, _ttField && _ttField.options);
      form.option_service = this.normChipValues(row.option_service, _osField && _osField.options);
      // 【P14】is_free 改数字值（1=否 2=是，与后端 selectValue 口径一致；旧版中文值后端 intval 会落 0）
      form.is_free = (row.is_free == 2) ? 2 : 1;
      form.remark = row.remark || "";
      // 回款计划：优先回读已有的计划（列表已返回 payment_plans），无则默认 1 行
      const rdPlans = (row.payment_plans && row.payment_plans.length)
        ? row.payment_plans.map(p => ({
            date: p.date ? String(p.date).slice(0, 10) : "",
            amount: (p.amount !== undefined && p.amount !== null) ? p.amount : ""
          }))
        : [{ date: "", amount: "" }];
      form.pay_plans = rdPlans;
      this.addForm = form;
      // 先按门店过滤会议室，再按客户过滤商机
      this.applyRoomStoreFilter();
      this.applyCustomerOppFilter();
      this.billFormMode = "edit";
      // 【P214】编辑态同样重拉关联会议室订单选项（与新增一致）
      this.loadMeetingRoomOrderOptions();
      /* 【P215】编辑态同样应用支付约束 */
      this.applyPaymentProductLimit();
      /* 【P218】编辑态同样加载发票的所属财务合同下拉 + 【P219】审批人下拉 */
      this.loadInvoiceFinanceContracts();
      this.loadInvoiceFinanceStaff();
    },

    // 删除某条会议室预订单：先弹出精美确认框，确认后再软删除（含关联回款计划）
    deleteRoomOrder(row) {
      if (!row || !row.sn) return;
      this.delRow = row;
      this.showDel = true;
    },

    // 确认删除：真正执行删除请求
    confirmDelete() {
      const row = this.delRow;
      if (!row || !row.sn) { this.showDel = false; return; }
      // 按当前单据页的 deleteFn 删除（会议室订单与其它单据走各自的接口）
      const tab = this.billTab || (this.tabConfigs || []).find(t => t.key === "room");
      if (!tab || typeof tab.deleteFn !== "function") {
        this.showDel = false;
        this.notice("删除功能未配置", "error");
        return;
      }
      this.saving = true;
      tab.deleteFn({ sn: row.sn }).then(res => {
        this.saving = false;
        this.showDel = false;
        if (res && res.code == 200) {
          this.notice(res.msg || "已删除", "success");
          // 删除后若正停留在表单页，退回列表（该记录数据已不存在）
          if (this.billFormMode) this.billFormMode = null;
          this.loadAllLists();
        } else {
          this.notice((res && res.msg) || "删除失败", "error");
        }
        this.delRow = null;
      }).catch(e => {
        this.saving = false;
        this.showDel = false;
        this.delRow = null;
        this.notice("删除失败（网络/接口异常）", "error");
      });
    },

    // 下拉选择
    openSheet(f) {
      // 只读字段（如「合同」）：不弹选择器
      if (f && f.readonly) return;
      this.sheetTarget = f.prop;
      this.sheetFill = f.fill || null;
      this.sheetTitle = "选择" + f.label;
      this.sheetOptions = (f.options || []).map(o => ({ name: o.label, value: o.value, extra: o }));
      this.sheetVisible = true;
    },

    // 下拉显示文本（存 code/sn，显示 label）
    selectText(f) {
      const v = this.addForm[f.prop];
      if (v === "" || v === undefined || v === null) return "";
      const hit = (f.options || []).find(o => String(o.value) === String(v));
      if (hit) return hit.label;
      /* 【P226 修复】取不到 label 时原来直接吐 value ⇒ 页面上显示一串 sn。
         发票「客户」「所属合同」就是这种情况：
           · 客户 options 为空（autoFill 写入 sn，无对应 option）；
           · 所属合同的 optionsFn 字典键后端一度不存在。
         改为：优先用编辑/详情回读的 nameKey 文本字段（形如 customer_name），
         仍取不到才退回 sn（保证不空白、便于排查）。 */
      if (f.nameKey) {
        const nm = (this.orderDetail && this.orderDetail[f.nameKey])
          || (this.addForm[f.nameKey])
          || (this.contract && this.contract[f.nameKey]);
        if (nm) return nm;
      }
      return v;
    },

    onSheetSelect(item) {
      this.$set(this.addForm, this.sheetTarget, item.value);
      // 联动回填（如选中会议室后自动填会议室编号）
      if (this.sheetFill) {
        Object.keys(this.sheetFill).forEach(k => {
          const key = this.sheetFill[k];
          this.$set(this.addForm, k, (item.extra && item.extra[key]) || "");
        });
      }
      this.sheetVisible = false;
      // 门店变化 → 立即按门店过滤会议室（不依赖 watch，避免 addForm 整体替换后 watch 不触发）
      if (this.sheetTarget === "stores_sn") {
        this.applyRoomStoreFilter();
      }
      // 客户变化 → 立即按客户过滤商机（二级联动）
      if (this.sheetTarget === "customer_sn") {
        this.applyCustomerOppFilter();
      }
      // 会议室 / 时段变化后自动带出市场价格与销售价格
      if (this.sheetTarget === "meeting_room_sn" || this.sheetTarget === "time_type_name") {
        this.applyRoomPrice();
      }
      // 【P9】合同类型变化 → 关联区显隐联动 + 清空被禁字段 + 拉取同类财务合同选项
      if (this.sheetTarget === "payment_product") {
        this.applyPaymentProductLink();
      }
    },

    // 【P9】fieldVisible：字段 showIf(form) 联动显隐（无 showIf 默认显示）
    fieldVisible(f) {
      if (!f || typeof f.showIf !== "function") return true;
      try { return !!f.showIf(this.addForm || {}); } catch (e) { return true; }
    },

    // 【P9】payment_product 联动：
    //   1 会议室   → 显示会议室订单多选；清增值订单
    //   2/3/5      → 显示增值订单；清会议室订单
    //   4 充值     → 两者都清
    //   同时拉取本合同同类财务合同选项（category = payment_product）
    applyPaymentProductLink() {
      const pp = Number(this.addForm.payment_product);
      if (pp === 1) {
        this.$set(this.addForm, "value_added_servicses_sn", "");
      } else {
        this.$set(this.addForm, "order_meeting_room", []);
      }
      this.$set(this.addForm, "financial_contracts_sn", "");
      this.loadFinanceContractOptions(pp);
    },

    // 【P9】本销售合同已有财务合同选项（按类别过滤；空列表 = 首次回款走审批后自动创建）
    loadFinanceContractOptions(pp) {
      const tab = (this.tabConfigs || []).find(t => t.key === "payment");
      if (!tab) return;
      const f = (tab.fields || []).find(x => x.prop === "financial_contracts_sn");
      if (!f) return;
      if (!(pp >= 1 && pp <= 5)) { this.$set(f, "options", []); return; }
      getFinanceContractOptionsData({ order_sn: this.sn, category: pp }).then(res => {
        if (!res || res.code != 200 || !res.data) return;
        const opts = (res.data.list || []).map(r => ({
          label: (r.serial_number ? r.serial_number + " · " : "") + (r.name || r.sn) + (r.amount !== undefined && r.amount !== null ? "（¥" + Number(r.amount).toFixed(2) + "）" : ""),
          value: r.sn
        }));
        this.$set(f, "options", opts);
      }).catch(e => console.log(e));
    },

    // 图片上传（本地单张）：van-uploader 选中后直传业务接口，返回可访问 URL 写回 addForm[字段]
    afterReadUpload(f, file) {
      const listKey = f.prop + "_list";
      const list = this.addForm[listKey] || [];
      const item = list[list.length - 1];
      if (item) {
        this.$set(item, "status", "uploading");
        this.$set(item, "message", "上传中");
      }
      const formData = new FormData();
      formData.append("file", file.file);
      uploadPaymentImage(formData).then(res => {
        if (res && res.code == 200 && res.data && res.data.url) {
          const url = res.data.url;
          this.$set(this.addForm, f.prop, url);
          if (item) {
            this.$set(item, "status", "done");
            this.$set(item, "url", url);
            this.$set(item, "isImage", true);
          }
        } else {
          this.notice((res && res.msg) || "上传失败", "error");
          if (item) this.$set(item, "status", "failed");
        }
      }).catch(() => {
        this.notice("上传失败", "error");
        if (item) this.$set(item, "status", "failed");
      });
    },

    // 删除已上传图片：清空写回的 URL
    onUploadDelete(f) {
      this.$set(this.addForm, f.prop, "");
    },

    // 会议室下拉选项（合同详情「添加会议室预订单」）：会议室(含分时段价格)/客户/商机/门店/合同
    loadRoomFormOptions() {
      getContractRoomFormOptionsData({}).then(res => {
        if (!res || res.code != 200 || !res.data) return;
        const d = res.data;
        const tab = (this.tabConfigs || []).find(t => t.key === "room");
        if (!tab) return;
        const setOpt = (prop, arr) => {
          const f = (tab.fields || []).find(x => x.prop === prop);
          if (f) this.$set(f, "options", arr || []);
        };
        // 全量缓存（用于联动过滤），同时初始化会议室下拉
        this.roomOptionsAll = (d.rooms || []).map(r => ({
          label: (r.name || r.sn) + (r.room_number ? " · " + r.room_number : ""),
          value: r.sn,
          name: r.name || "",
          room_number: r.room_number || "",
          store_sn: r.store_sn || "",
          prices: r.prices || {}
        }));
        setOpt("meeting_room_sn", this.roomOptionsAll.slice());
        setOpt("customer_sn", (d.customers || []).map(r => ({
          label: (r.name || r.sn) + (r.serial_number ? " · " + r.serial_number : ""),
          value: r.sn
        })));
        setOpt("opportunitie_sn", (d.opportunities || []).map(r => ({
          label: (r.name || r.sn) + (r.serial_number ? " · " + r.serial_number : ""),
          value: r.sn
        })));
        // 全量缓存商机（含 customer_sn），用于「客户→商机」二级联动过滤
        this.opportunityOptionsAll = (d.opportunities || []).map(r => ({
          label: (r.name || r.sn) + (r.serial_number ? " · " + r.serial_number : ""),
          value: r.sn,
          customer_sn: r.customer_sn || ""
        }));
        setOpt("stores_sn", (d.stores || []).map(r => ({
          label: (r.name || r.sn) + (r.store_number ? " · " + r.store_number : ""),
          value: r.sn
        })));
        const contractOpts = (d.contracts || []).map(r => ({
          label: (r.name || r.sn) + (r.serial_number ? " · " + r.serial_number : ""),
          value: r.sn
        }));
        // 兜底：当前合同可能不在最新 300 条列表里，补进去，避免默认选中项只显示 sn
        if (this.sn && !contractOpts.some(o => String(o.value) === String(this.sn))) {
          contractOpts.unshift({
            label: (this.contract && this.contract.name ? this.contract.name : "当前合同")
              + (this.contract && this.contract.serial_number ? " · " + this.contract.serial_number : ""),
            value: this.sn
          });
        }
        setOpt("contracts_sn", contractOpts);
        // 【P33 修复】桌型/增值服务选项：value 必须取数据库 id
        //   （老系统落库口径 [[248],[249]] 即 t_pro_table_types.id / t_pro_value_added_services.id）。
        //   此前 RoomOrders.js 硬编码中文名 value，配合 join(",") 提交，被后端整段丢弃。
        //   这里复用 H5 会议室订单页的表单接口，与表数据保持同源，无需再硬编码。
        getRoomOrderFormData({}).then(fres => {
          if (!fres || fres.code != 200 || !fres.data) return;
          const fd = fres.data;
          const toOpts = (arr) => (arr || []).map(r => ({
            label: r.name || String(r.id),
            value: r.id
          }));
          setOpt("table_types", toOpts(fd.table_types));
          setOpt("option_service", toOpts(fd.option_service));
          // 编辑态兜底：选项就绪后把已回填的芯片值再归一一次
          // （历史数据可能是中文名逗号串，需借 label→value 映射回 id；该操作幂等）
          if (this.editingSn && this.addForm) {
            ["table_types", "option_service"].forEach(prop => {
              const f = (tab.fields || []).find(x => x.prop === prop);
              if (f) this.$set(this.addForm, prop, this.normChipValues(this.addForm[prop], f.options));
            });
          }
        }).catch(e => console.log(e));
      }).catch(e => console.log(e));
    },

    /* 【P214】单独抽出「关联会议室订单」选项加载。
       原先它只在 created() 里随 loadPaymentFormOptions 拉一次 ⇒ 新增会议室订单后
       再打开支付单表单看不到新单，必须刷新浏览器（BUG 反馈）。
       独立出来后可在 openAdd / openEdit 时重拉。
       ⚠️ 不要用 loadPaymentFormOptions() 代替：它尾部会写 this.addForm.approval_user_id，
          在 openAdd 之外调用会覆盖用户已填的审批人。 */
    /* ================= 【P215】支付单按合同类型的约束 ================= */
    /** 父销售合同是否为「充值合同」：t_pro_orders.type === 2 */
    isRechargeContract() {
      return Number(this.contract && this.contract.type) === 2;
    },
    /* 【P215 0002】充值合同只能余额支付：收敛支付方式选项 + 自动置 6。
       【P215 0003】非充值合同不能选「充值」类型(payment_product=4)：从选项里剔除。
       两处都在 openAdd / openEdit 时调用，保证新增与编辑一致生效。 */
    /* ================= 【P219】发票标题 JS 生成 + 审批人下拉 ================= */
    /** 【P219】选发票类型时生成标题：客户名_发票类型_yymmddHHii
     *  例：王小莹_增值祱普通_261004213012
     *  客户名取自当前销售合同；取不到时回退「客户」。
     *  已手动改过标题则不覆盖（尊重用户输入）。 */
    buildInvoiceTitle(typeVal, form) {
      const f = form || this.addForm || {};
      if (f.__titleEdited) return f.title || "";
      const typeMap = { 1: "增值祱普通", 2: "增值祱专用" };
      const typeName = typeMap[Number(typeVal) || f.type] || "";
      if (!typeName) return f.title || "";
      /* 客户名：合同上的客户名 → 客户列表里查 */
      let cusName = this.orderDetail && (this.orderDetail.customer_name || "");
      if (!cusName) {
        const cId = (this.orderDetail && this.orderDetail.customer_sn) || f.customer_sn;
        const list = this.customerOptions || [];
        const hit = list.find(x => String(x.value) === String(cId));
        if (hit) cusName = hit.label || "";
      }
      if (!cusName) {
        const t = (this.addForm && this.addForm.__customerName) || "";
        cusName = t;
      }
      if (!cusName) cusName = "客户";
      const d = new Date();
      const p2 = n => (n < 10 ? "0" + n : "" + n);
      const stamp = String(d.getFullYear()).slice(2) + p2(d.getMonth() + 1) + p2(d.getDate())
        + p2(d.getHours()) + p2(d.getMinutes()) + p2(d.getSeconds());
      return cusName + "_" + typeName + "_" + stamp;
    },
    /** 【P219】发票的审批人下拉：复用 mixin:1089 的 getFinanceStaffListData 同源逻辑
     *  （该处原本只给 payment/refund 两个 tab 灌 options，发票被漏掉 ⇒ 审批人永远空白） */
    loadInvoiceFinanceStaff(cb) {
      getFinanceStaffListData({}).then(fres => {
        if (!fres || fres.code != 200 || !fres.data) { if (cb) cb([]); return; }
        const opts = (fres.data.list || []).map(r => ({ label: r.name || r.sn, value: r.id }));
        const tab = (this.tabConfigs || []).find(t => t.key === "invoice");
        if (tab) {
          const f = (tab.fields || []).find(x => x.prop === "approval_user_id");
          if (f) this.$set(f, "options", opts);
        }
        /* 默认选中后端给的财务默认人（陈凯蕾 466）—— 避免「审批人是空的」还要手选 */
        if (this.addForm && !this.addForm.approval_user_id && fres.data.default) {
          this.$set(this.addForm, "approval_user_id", fres.data.default);
        }
        if (cb) cb(opts);
      }).catch(() => { if (cb) cb([]); });
    },

    /* ================= 【P219】发票标题 JS 生成 + 审批人下拉 ================= */
    /** 【P219】选发票类型时生成标题：客户名_发票类型_yymmddHHii
     *  例：王小莹_增值祱普通_261004213012
     *  客户名取自当前销售合同；取不到时回退「客户」。
     *  已手动改过标题则不覆盖（尊重用户输入）。 */
    buildInvoiceTitle(typeVal, form) {
      const f = form || this.addForm || {};
      if (f.__titleEdited) return f.title || "";
      const typeMap = { 1: "增值祱普通", 2: "增值祱专用" };
      const typeName = typeMap[Number(typeVal) || f.type] || "";
      if (!typeName) return f.title || "";
      /* 客户名：合同上的客户名 → 客户列表里查 */
      let cusName = this.orderDetail && (this.orderDetail.customer_name || "");
      if (!cusName) {
        const cId = (this.orderDetail && this.orderDetail.customer_sn) || f.customer_sn;
        const list = this.customerOptions || [];
        const hit = list.find(x => String(x.value) === String(cId));
        if (hit) cusName = hit.label || "";
      }
      if (!cusName) {
        const t = (this.addForm && this.addForm.__customerName) || "";
        cusName = t;
      }
      if (!cusName) cusName = "客户";
      const d = new Date();
      const p2 = n => (n < 10 ? "0" + n : "" + n);
      const stamp = String(d.getFullYear()).slice(2) + p2(d.getMonth() + 1) + p2(d.getDate())
        + p2(d.getHours()) + p2(d.getMinutes()) + p2(d.getSeconds());
      return cusName + "_" + typeName + "_" + stamp;
    },
    /** 【P219】发票的审批人下拉：复用 mixin:1089 的 getFinanceStaffListData 同源逻辑
     *  （该处原本只给 payment/refund 两个 tab 灌 options，发票被漏掉 ⇒ 审批人永远空白） */
    loadInvoiceFinanceStaff(cb) {
      getFinanceStaffListData({}).then(fres => {
        if (!fres || fres.code != 200 || !fres.data) { if (cb) cb([]); return; }
        const opts = (fres.data.list || []).map(r => ({ label: r.name || r.sn, value: r.id }));
        const tab = (this.tabConfigs || []).find(t => t.key === "invoice");
        if (tab) {
          const f = (tab.fields || []).find(x => x.prop === "approval_user_id");
          if (f) this.$set(f, "options", opts);
        }
        /* 默认选中后端给的财务默认人（陈凯蕾 466）—— 避免「审批人是空的」还要手选 */
        if (this.addForm && !this.addForm.approval_user_id && fres.data.default) {
          this.$set(this.addForm, "approval_user_id", fres.data.default);
        }
        if (cb) cb(opts);
      }).catch(() => { if (cb) cb([]); });
    },

    /* ================= 【P218】财务发票专用逻辑 ================= */
    /** 发票的「所属合同」下拉：本销售合同产生的财务合同（pro_contracts.order_sn = 本合同 sn） */
    loadInvoiceFinanceContracts(cb) {
      const invTab = (this.tabConfigs || []).find(t => t.key === "invoice");
      if (!invTab) { if (cb) cb([]); return; }
      const f = (invTab.fields || []).find(x => x.prop === "contracts_sn");
      if (!f) { if (cb) cb([]); return; }
      getFinanceContractOptionsData({ order_sn: this.sn }).then(res => {
        if (!res || res.code != 200 || !res.data) { if (cb) cb([]); return; }
        const list = (res.data.list || res.data || []);
        const arr = Array.isArray(list) ? list : [];
        this.$set(f, "options", arr.map(r => ({
          label: (r.serial_number ? r.serial_number + " · " : "") + (r.name || r.sn)
               + (r.amount !== undefined && r.amount !== null ? "（¥" + Number(r.amount).toFixed(2) + "）" : ""),
          value: r.sn
        })));
        if (cb) cb(this.$get ? null : arr);
      }).catch(() => { if (cb) cb([]); });
    },
    /* 【P218】发票的自动关联：客户 / 销售合同 / 财务合同选项 */
    applyInvoiceAutoFill(tab) {
      if (!tab || tab.key !== "invoice") return;
      /* 【P226 修复】发票「客户」显示 SN 的根因：这里只处理了商机(applyCustomerOppFilter)，
         客户的 options 从未被填充 ⇒ selectText() 找不到 label ⇒ 直接显示 sn。
         补：把本销售合同的客户写成**唯一一项**的 options，
         这样 readonly 单元格就能显示客户名称而不是 sn。 */
      const fCust = (tab.fields || []).find(x => x.prop === "customer_sn");
      if (fCust) {
        const csn = (this.contract && this.contract.customer_sn)
          || (this.orderDetail && this.orderDetail.customer_sn) || "";
        const cname = (this.orderDetail && this.orderDetail.customer_name)
          || (this.contract && this.contract.customer_name) || "";
        const opts = [];
        if (csn) opts.push({ label: cname || csn, value: csn });
        this.$set(fCust, "options", opts);
      }
      this.applyCustomerOppFilter();
      this.loadInvoiceFinanceContracts();
      /* 【P219】审批人下拉（原来完全没有加载逻辑 ⇒ 永远空白） */
      this.loadInvoiceFinanceStaff();
      /* 【P219】已选发票类型时同步生成标题（编辑态 / 草稿恢复） */
      if (this.addForm && this.addForm.type) {
        const t = this.buildInvoiceTitle(this.addForm.type, this.addForm);
        if (t && t !== this.addForm.title) this.$set(this.addForm, "title", t);
      }
    },

    applyPaymentProductLimit() {
      const payTab = (this.tabConfigs || []).find(t => t.key === "payment");
      if (!payTab) return;
      const isRecharge = this.isRechargeContract();
      const fields = payTab.fields || [];

      // ① 支付方式：充值合同只留「余额」
      const fMethod = fields.find(x => x.prop === "payment_method");
      if (fMethod) {
        this.$set(fMethod, "fullOptions", fMethod.fullOptions || (fMethod.options || []).slice());
        const full = fMethod.fullOptions || [];
        const allowed = (fMethod.optionsByContractType || {})[2] || null;
        this.$set(fMethod, "options", isRecharge && allowed ? allowed.slice() : full.slice());
        // 已选值若被收敛掉，自动纠正为唯一可选值
        if (isRecharge && allowed) {
          const cur = Number(this.addForm.payment_method || 0);
          const ok = allowed.some(o => Number(o.value) === cur);
          if (!ok) { this.$set(this.addForm, "payment_method", allowed[0].value); }
          this.$set(this.addForm, "pay_type", allowed[0].pay_type || "");
        }
      }

      // ② 合同类型（payment_product）：非充值合同剔除「充值」(4)
      const fProd = fields.find(x => x.prop === "payment_product");
      if (fProd) {
        this.$set(fProd, "fullOptions", fProd.fullOptions || (fProd.options || []).slice());
        const full = fProd.fullOptions || [];
        const drop = (fProd.excludeByContractType || {}).notRecharge;
        const opts = (!isRecharge && drop)
          ? full.filter(o => Number(o.value) !== Number(drop))
          : full.slice();
        this.$set(fProd, "options", opts);
        if (!isRecharge && drop && Number(this.addForm.payment_product) === Number(drop)) {
          this.$set(this.addForm, "payment_product", opts.length ? opts[0].value : "");
        }
      }
    },

    /* 【P225】★ 只列「审核通过」的会议室订单（status=1），与 :1180 首次加载口径保持一致。
       权威口径 BillListService.php:851-853（0 审核中 / 1 通过 / 2 驳回），
       query() 原生支持 status 过滤（:569-570）⇒ 下推后端，前端不筛。
       ★ 两处必须同步改，否则会出现「新增时只看到审核通过、编辑/重拉时又看到全部」的不一致。 */
    loadMeetingRoomOrderOptions(cb) {
      if (!this.sn) { if (cb) cb(); return; }
      const payTab = (this.tabConfigs || []).find(t => t.key === "payment");
      if (!payTab) { if (cb) cb(); return; }
      const f = (payTab.fields || []).find(x => x.prop === "order_meeting_room");
      if (!f) { if (cb) cb(); return; }
      getContractRoomOrderListData({ sn: this.sn, page: 1, pageSize: 500, status: 1 }).then(rres => {
        if (!rres || rres.code != 200) { if (cb) cb(); return; }
        const rows = (rres.data && (rres.data.list || rres.data)) || [];
        const list = Array.isArray(rows) ? rows : [];
        this.$set(f, "options", list.map(r => ({
          label: (r.name || r.sn) + (r.on_site_time ? " · " + String(r.on_site_time).slice(0, 10) : "")
               + (r.amount !== undefined && r.amount !== null ? " · ¥" + Number(r.amount).toFixed(2) : ""),
          value: (r.id !== undefined && r.id !== null && r.id !== "") ? r.id : r.sn,
          _sn: r.sn
        })));
        this.$set(this, "roomOrderOptCount", list.length);
        if (cb) cb(list);
      }).catch(() => { if (cb) cb(); });
    },

    // 支付单 tab 选项（复用同一份 options 数据，单接口）：客户/商机/合同/会议室/增值服务订单
    loadPaymentFormOptions() {
      getContractRoomFormOptionsData({}).then(res => {
        if (!res || res.code != 200 || !res.data) return;
        const d = res.data;
        const tab = (this.tabConfigs || []).find(t => t.key === "payment");
        if (!tab) return;
        const setPayOpt = (prop, arr) => {
          const f = (tab.fields || []).find(x => x.prop === prop);
          if (f) this.$set(f, "options", arr || []);
        };
        setPayOpt("customer_sn", (d.customers || []).map(r => ({
          label: (r.name || r.sn) + (r.serial_number ? " · " + r.serial_number : ""),
          value: r.sn
        })));
        setPayOpt("opportunitie_sn", (d.opportunities || []).map(r => ({
          label: (r.name || r.sn) + (r.serial_number ? " · " + r.serial_number : ""),
          value: r.sn
        })));
        const payContractOpts = (d.contracts || []).map(r => ({
          label: (r.name || r.sn) + (r.serial_number ? " · " + r.serial_number : ""),
          value: r.sn
        }));
        if (this.sn && !payContractOpts.some(o => String(o.value) === String(this.sn))) {
          payContractOpts.unshift({
            label: (this.contract && this.contract.name ? this.contract.name : "当前合同")
              + (this.contract && this.contract.serial_number ? " · " + this.contract.serial_number : ""),
            value: this.sn
          });
        }
        setPayOpt("contracts_sn", payContractOpts);
        // 【P9】关联会议室订单选项：改用本销售合同内的会议室预订单（不再是全量会议室实体）
        // 【P13】value 改用 id（老系统 PC 端选项即 id，存储 JSON [[id],...]；sn 无法与老数据互通）
        // 【P225】★ 只列「审核通过」的订单（status=1）。
        //   权威口径：BillListService.php:851-853 `t_pro_orders_meeting_room.status`
        //             0=审核中 / 1=通过 / 2=驳回。
        //   依据：BillListService.php:569-570 `query()` 原生支持 `status` 参数
        //        （intval 后 where status=），故直接下推给后端过滤，**不在前端过滤**
        //        —— 避免拉回一堆审核中的单再在前端筛掉。
        getContractRoomOrderListData({ sn: this.sn, page: 1, pageSize: 100, status: 1 }).then(rres => {
          if (!rres || rres.code != 200) return;
          const rows = (rres.data && (rres.data.list || rres.data)) || [];
          const list = Array.isArray(rows) ? rows : [];
          setPayOpt("order_meeting_room", list.map(r => ({
            label: (r.name || r.sn) + (r.on_site_time ? " · " + String(r.on_site_time).slice(0, 10) : "") + (r.amount !== undefined && r.amount !== null ? " · ¥" + Number(r.amount).toFixed(2) : ""),
            value: (r.id !== undefined && r.id !== null && r.id !== "") ? r.id : r.sn
          })));
        }).catch(e => console.log(e));
        setPayOpt("value_added_servicses_sn", (d.value_added_services || []).map(r => ({
          label: (r.name || r.sn) + (r.title ? " · " + r.title : ""),
          value: r.sn
        })));
        // 06 受理人下拉：默认选中当前登录人（localStorage 里的 staff id），可改
        const staffOpts = (d.staff || []).map(r => ({
          label: r.name || r.sn,
          value: r.id
        }));
        setPayOpt("owner_id", staffOpts);
      }).catch(e => console.log(e));
      // 【P9/P13】审批人下拉：财务部门人员（默认陈凯蕾置顶）；支付单与退款单共用
      getFinanceStaffListData({}).then(fres => {
        if (!fres || fres.code != 200 || !fres.data) return;
        const opts = (fres.data.list || []).map(r => ({ label: r.name || r.sn, value: r.id }));
        ["payment", "refund"].forEach(tk => {
          const tab = (this.tabConfigs || []).find(t => t.key === tk);
          if (!tab) return;
          const f = (tab.fields || []).find(x => x.prop === "approval_user_id");
          if (f) this.$set(f, "options", opts);
        });
        if (!this.addForm.approval_user_id && fres.data.default) {
          this.$set(this.addForm, "approval_user_id", fres.data.default);
        }
      }).catch(e => console.log(e));
      // 【P13-R2】退款单 tab 选项：关联合同（本销售合同的财务合同）+ method=3 转移目标（同客户非充值合同 top5）
      const rfTab = (this.tabConfigs || []).find(t => t.key === "refund");
      if (rfTab) {
        const setRfOpt = (prop, arr) => {
          const f = (rfTab.fields || []).find(x => x.prop === prop);
          if (f) this.$set(f, "options", arr || []);
        };
        getFinanceContractOptionsData({ order_sn: this.sn }).then(res => {
          if (!res || res.code != 200 || !res.data) return;
          setRfOpt("contracts_sn", (res.data.list || []).map(r => ({
            label: (r.serial_number ? r.serial_number + " · " : "") + (r.name || r.sn) + (r.amount !== undefined && r.amount !== null ? "（¥" + Number(r.amount).toFixed(2) + "）" : ""),
            value: r.sn
          })));
        }).catch(e => console.log(e));
        getRefundTransferOptionsData({ sn: this.sn }).then(res => {
          if (!res || res.code != 200 || !res.data) return;
          setRfOpt("to_order_sn", (res.data.list || []).map(r => ({
            label: (r.name || r.sn) + (r.serial_number ? " · " + r.serial_number : ""),
            value: r.sn
          })));
        }).catch(e => console.log(e));
      }
    },

    // 按「会议室 + 时段」自动带出市场价格 / 销售价格
    // 05 市场价格为价目表定价固定不可改：切换会议室/时段后强制覆盖（忽略手填/旧值）；销售价仍仅空时带出
    applyRoomPrice() {
      const tab = (this.tabConfigs || []).find(t => t.key === "room");
      if (!tab) return;
      const f = (tab.fields || []).find(x => x.prop === "meeting_room_sn");
      if (!f) return;
      const hit = (f.options || []).find(o => String(o.value) === String(this.addForm.meeting_room_sn));
      if (!hit || !hit.prices) return;
      const p = hit.prices[String(this.addForm.time_type_name)];
      if (!p) return;
      this.$set(this.addForm, "price", p.norm_price);
      if (!this.addForm.amount) this.$set(this.addForm, "amount", p.sale_price);
    },

    // 按「门店」过滤会议室；已选会议室被过滤掉则自动清空（连同隐藏字段和金额）
    applyRoomStoreFilter() {
      const tab = (this.tabConfigs || []).find(t => t.key === "room");
      if (!tab) return;
      const f = (tab.fields || []).find(x => x.prop === "meeting_room_sn");
      if (!f) return;
      const sn = this.addForm && this.addForm.stores_sn;
      // 选项尚未加载完成时不处理，避免把下拉清空成空列表
      if (!this.roomOptionsAll || !this.roomOptionsAll.length) return;
      let list = this.roomOptionsAll || [];
      if (sn) list = list.filter(r => String(r.store_sn || "") === String(sn));
      this.$set(f, "options", list);
      const cur = this.addForm && this.addForm.meeting_room_sn;
      if (cur && !list.some(o => String(o.value) === String(cur))) {
        this.$set(this.addForm, "meeting_room_sn", "");
        this.$set(this.addForm, "meeting_room_name", "");
        this.$set(this.addForm, "meeting_room_room_number", "");
        this.$set(this.addForm, "price", "");
        this.$set(this.addForm, "amount", "");
      }
    },

    // 按「客户」过滤商机；已选商机若不属于该客户则自动清空
    applyCustomerOppFilter() {
      const tab = (this.tabConfigs || []).find(t => t.key === "room");
      if (!tab) return;
      const f = (tab.fields || []).find(x => x.prop === "opportunitie_sn");
      if (!f) return;
      // 选项尚未加载完成时不处理，避免把下拉清空成空列表
      if (!this.opportunityOptionsAll || !this.opportunityOptionsAll.length) return;
      const cust = this.addForm && this.addForm.customer_sn;
      let list = this.opportunityOptionsAll || [];
      if (cust) list = list.filter(o => String(o.customer_sn || "") === String(cust));
      this.$set(f, "options", list);
      const cur = this.addForm && this.addForm.opportunitie_sn;
      if (cur && !list.some(o => String(o.value) === String(cur))) {
        this.$set(this.addForm, "opportunitie_sn", "");
      }
    },

    // 多选 chip
    isChipOn(arr, val) {
      return (arr || []).some(v => String(v) === String(val));
    },

    /**
     *【P33 修复】多选字段值归一：把后端返回的各种形态统一拍平成「芯片 value 数组」。
     *
     * 覆盖形态：
     *   二维 id 数组  [[248],[249]]    （老系统 / 修复后新数据，权威口径）
     *   一维 id 数组  [248,249]
     *   JSON 字符串   '[[248],[249]]'
     *   逗号串数字    "248,249"
     *   逗号串中文名  "回字型,U型式"    （历史脏数据；借 options 的 label→value 映射回 id）
     *
     * 返回值统一为 String 数组；isChipOn() 本身按字符串比较，可正确匹配数字型 value。
     * ⚠️ 这是「编辑时表单读取错误」的直接修复：原实现用 String(row.x).split(",")，
     *    会把 '[[248],[249]]' 拆成 ['[[248]', '[249]]'] 这类乱码，导致芯片全不亮。
     */
    normChipValues(raw, opts) {
      if (raw === undefined || raw === null || raw === "") return [];
      let arr = raw;
      if (typeof raw === "string") {
        const t = raw.trim();
        if (!t) return [];
        let parsed = null;
        try { parsed = JSON.parse(t); } catch (e) { parsed = null; }
        arr = Array.isArray(parsed) ? parsed : t.split(",").filter(s => s !== "");
      }
      if (!Array.isArray(arr)) return [];
      const flat = [];
      arr.forEach(it => {
        const v = Array.isArray(it) ? it[0] : it;
        if (v === undefined || v === null || v === "") return;
        flat.push(String(v).trim());
      });
      if (!flat.length) return [];
      const list = opts || [];
      return flat.map(v => {
        const hit = list.find(o => String(o.value) === v) || list.find(o => String(o.label) === v);
        return hit ? String(hit.value) : v;
      });
    },

    /**
     *【P33 修复】使用时间归一：把 start_time 的存量形态统一成 { begin, end }。
     *   数组 / JSON 数组 ["08:30","20:30"]（老系统与修复后新数据）
     *   文本 "08:30~20:30" / "08:30-20:30" / "08:30至20:30"
     *   顺带把 "0830" / "8:30" / "8：30" 归一成 "08:30"（id=68804 即存了 "0830"）
     * ⚠️ 这是「编辑时使用时间空白」的直接修复：原实现只在含 "~" 时才回填。
     */
    normTimeRange(raw) {
      const empty = { begin: "", end: "" };
      const pad2 = n => (n < 10 ? "0" : "") + n;
      const fixTime = v => {
        const t = String(v).trim().replace(/：/g, ":");
        let m = t.match(/^(\d{1,2}):(\d{1,2})$/);
        if (m) {
          const h = Number(m[1]), i = Number(m[2]);
          if (h <= 23 && i <= 59) return pad2(h) + ":" + pad2(i);
        }
        m = t.match(/^(\d{3,4})$/);
        if (m) {
          const s = ("0000" + m[1]).slice(-4);
          const h = Number(s.slice(0, 2)), i = Number(s.slice(2, 4));
          if (h <= 23 && i <= 59) return pad2(h) + ":" + pad2(i);
        }
        return t;
      };
      if (raw === undefined || raw === null || raw === "") return empty;
      let arr = raw;
      //【P33 加固】对象形态 { begin, end } —— 这是本模块 addForm 的运行时规范形态，
      //  以下分支保证 normTimeRange 是「全域函数」：任何路径把 addForm.start_time 再喂进来
      //  都不会被误判成非法值而清空（否则等于静默清掉用户已选时间）。
      if (typeof raw === "object" && !Array.isArray(raw)) {
        const b = fixTime(raw.begin === undefined ? "" : raw.begin);
        const e = fixTime(raw.end === undefined ? "" : raw.end);
        if (!b && !e) return empty;
        return { begin: b || e, end: e || b };
      }
      if (typeof raw === "string") {
        const t = raw.trim();
        if (!t) return empty;
        let parsed = null;
        try { parsed = JSON.parse(t); } catch (e) { parsed = null; }
        if (Array.isArray(parsed)) arr = parsed;
        else arr = t.split(/[~\-至到]/).map(s => s.trim()).filter(Boolean);
      }
      if (!Array.isArray(arr)) return empty;
      const parts = arr.map(v => (Array.isArray(v) ? v[0] : v))
        .filter(v => v !== undefined && v !== null && v !== "")
        .map(v => fixTime(v));
      if (!parts.length) return empty;
      return { begin: parts[0], end: parts.length > 1 ? parts[1] : parts[0] };
    },

    // 【P9】multiselect（关联会议室订单）：单项 toggle / 全选
    toggleMulti(f, val) {
      const cur = (this.addForm[f.prop] || []).slice();
      const idx = cur.findIndex(v => String(v) === String(val));
      if (idx >= 0) { cur.splice(idx, 1); } else { cur.push(val); }
      this.$set(this.addForm, f.prop, cur);
    },
    isMultiAllOn(f) {
      const opts = f.options || [];
      const cur = this.addForm[f.prop] || [];
      return opts.length > 0 && cur.length === opts.length;
    },
    toggleMultiAll(f) {
      const opts = (f.options || []).map(o => o.value);
      if (this.isMultiAllOn(f)) {
        this.$set(this.addForm, f.prop, []);
      } else {
        this.$set(this.addForm, f.prop, opts.slice());
      }
    },

    toggleChip(f, val) {
      const arr = this.addForm[f.prop] ? this.addForm[f.prop].slice() : [];
      const i = arr.findIndex(v => String(v) === String(val));
      if (i >= 0) arr.splice(i, 1);
      else arr.push(val);
      this.$set(this.addForm, f.prop, arr);
    },

    // 回款计划
    addPayPlan() {
      const arr = this.addForm.pay_plans ? this.addForm.pay_plans.slice() : [];
      arr.push({ date: "", amount: "" });
      this.$set(this.addForm, "pay_plans", arr);
    },

    delPayPlan(i) {
      const arr = (this.addForm.pay_plans || []).slice();
      if (arr.length <= 1) { arr.splice(i, 1); this.$set(this.addForm, "pay_plans", [{ date: "", amount: "" }]); return; }
      arr.splice(i, 1);
      this.$set(this.addForm, "pay_plans", arr);
    },

    //【P33】使用时间：打开滑动选择器（开始默认 08:30 / 结束默认 20:30）
    openTimePick(prop, which) {
      const v = (this.addForm && this.addForm[prop]) || {};
      this.timeTarget = prop;
      this.timeTargetWhich = which === "end" ? "end" : "begin";
      this.timeCurrent = v[this.timeTargetWhich]
        || (this.timeTargetWhich === "end" ? "20:30" : "08:30");
      this.timeVisible = true;
    },
    //【P33】使用时间：确认写入（兼容 Vant 回传 Date 或 "HH:mm" 字符串）
    onTimeConfirm(value) {
      let t = value;
      if (t instanceof Date) {
        t = ("0" + t.getHours()).slice(-2) + ":" + ("0" + t.getMinutes()).slice(-2);
      }
      t = String(t == null ? "" : t).trim().replace(/：/g, ":");
      if (!t) { this.timeVisible = false; return; }
      const prop = this.timeTarget;
      const which = this.timeTargetWhich === "end" ? "end" : "begin";
      const cur = Object.assign({ begin: "", end: "" }, this.addForm[prop] || {});
      cur[which] = t;
      this.$set(this.addForm, prop, cur);
      this.timeVisible = false;
    },

    openDatePick(prop, planIndex) {
      this.dateTarget = prop;
      this.datePlanIndex = (planIndex === undefined || planIndex === null) ? -1 : planIndex;
      this.dateVisible = true;
    },

    onDateConfirm(val) {
      const y = val.getFullYear();
      const m = String(val.getMonth() + 1).padStart(2, "0");
      const d = String(val.getDate()).padStart(2, "0");
      const text = y + "-" + m + "-" + d;
      if (this.datePlanIndex >= 0) {
        const arr = (this.addForm[this.dateTarget] || []).slice();
        if (arr[this.datePlanIndex]) {
          arr[this.datePlanIndex] = Object.assign({}, arr[this.datePlanIndex], { date: text });
          this.$set(this.addForm, this.dateTarget, arr);
        }
      } else {
        this.$set(this.addForm, this.dateTarget, text);
      }
      this.dateVisible = false;
      this.datePlanIndex = -1;
    },

    // chips→逗号串，range→"开始~结束"，plans→payment 数组
    buildAddPayload() {
      try {
        const tab = this.activeAddTab || {};
        const payload = { sn: this.sn, order_sn: this.sn };
        (tab.fields || []).forEach(f => {
          if (!f || !f.prop) return;
          // 【P20】showIf=false 的字段（如充值类型下的会议室订单）不进 payload，避免隐藏字段残留值触发后端互斥校验误报
          if (!this.fieldVisible(f)) return;
          /* 【P100】notice 为纯展示的提示条（如「余额支付免财务审核」），不是表单字段，不进 payload */
          if (f.type === "notice") return;
          if (f.type === "plans") {
            payload.payment = (this.addForm[f.prop] || []).map(r => ({
              date: r && r.date ? r.date : "",
              amount: r && r.amount !== "" && r.amount !== undefined && r.amount !== null ? Number(r.amount) : 0
            }));
            return;
          }
          let v = this.addForm[f.prop];
          if (f.type === "chips") {
            //【P33 修复】桌型/增值服务必须提交「数组」，由后端归一为老系统二维 [[id],[id]]。
            //  此前统一 join(",") 会把中文名拼成 "回字型,U型式" 提交，后端按「非纯数字」
            //  判定后整段退回 []，导致桌型/增值服务静默丢失（id=68804 落库 [] 即此原因）。
            //  其余 chips 字段维持原有逗号串协议，避免波及其他单据。
            if (f.prop === "table_types" || f.prop === "option_service") {
              v = Array.isArray(v)
                ? v.filter(x => x !== undefined && x !== null && String(x) !== "")
                : [];
            } else {
              v = (v || []).join(",");
            }
          } else if (f.type === "multiselect") {
            // 【P13】对齐老系统存储：关联会议室订单 → JSON [[id],...]（admin json_decode 后按 id 金额校验/统计）；
            // 其他 multiselect 维持逗号串
            if (f.prop === "order_meeting_room") {
              const ids = (v || []).map(x => Number(x)).filter(x => !isNaN(x) && x > 0);
              // 【P20】空选不发 "[]"（后端按非空字符串误判为已关联会议室订单），发空串走必选校验
              v = ids.length ? JSON.stringify(ids.map(id => [id])) : "";
            } else {
              v = (v || []).join(",");
            }
          } else if (f.type === "range") {
            const b = (v && v.begin) || "";
            const e = (v && v.end) || "";
            v = (b || e) ? (b + "~" + e) : "";
          } else if (f.type === "discount") {
            v = this.discountText || "";
          }
          payload[f.prop] = v === undefined ? "" : v;
        });
        // 【P14】会议室订单免费单：销售价格默认 0 元、无需回款计划（后端同口径：免费不取价目表、计划强制清空）
        if (tab.key === "room" && Number(this.addForm.is_free) === 2) {
          payload.amount = 0;
          payload.payment = [];
        }
        return payload;
      } catch (err) {
        console.error("[buildAddPayload] error", err);
        throw err;
      }
    },

    submitAdd(action) {
      this.saveDebug = "1. 进入 submitAdd";
      try {
        const tab = this.activeAddTab || {};
        const fields = tab.fields || [];
        this.saveDebug = "2. tab=" + (tab.title || '-') + " saveFn=" + (typeof tab.saveFn);
        if (!tab || !tab.saveFn) {
          this.saveDebug = "ERR: 保存入口未配置";
          this.notice("保存入口未配置，请刷新重试", "error");
          return;
        }
        // 必填校验（数字 0 不应视为空）
        for (let f of fields) {
          if (!f.required) continue;
          // 【P9】showIf 为 false 的字段跳过必填校验（如未选合同类型时隐藏的关联字段）
          if (typeof f.showIf === "function" && !f.showIf(this.addForm || {})) continue;
          const v = this.addForm[f.prop];
          const isEmpty = (v === "" || v === undefined || v === null);
          if (f.type === "chips" || f.type === "multiselect") {
            if (!(v && v.length)) { this.saveDebug = "ERR: 请选择" + f.label; this.notice("请选择" + f.label, "error"); return; }
          } else if (f.type === "range") {
            if (!(v && v.begin && v.end)) { this.saveDebug = "ERR: 请填写" + f.label; this.notice("请填写" + f.label, "error"); return; }
          } else if (isEmpty) {
            this.saveDebug = "ERR: 请填写" + f.label; this.notice("请填写" + f.label, "error"); return;
          }
        }
        this.saveDebug = "3. 校验通过，正在组装 payload";
        const payload = this.buildAddPayload();
        if (this.editingSn) { payload.sn = this.editingSn; payload.order_sn = this.editingSn; }
        // 【P12/P13】支付单/退款单双动作：submit=提交审批 / draft=存草稿；其他单据不带 action
        /* 【P218】发票审批与支付单一致：submit=提交审批 / draft=存草稿 */
        if (tab.key === "payment" || tab.key === "refund" || tab.key === "invoice") payload.action = (action === "submit") ? "submit" : "draft";
        this.saveDebug = "4. payload 组装完成，准备发送请求" + (this.editingSn ? "（编辑：" + this.editingSn + "）" : "");
        this.saving = true;
        // 编辑态必须走 editFn；绝不允许回退到 saveFn（否则会新增一条而非更新）
        let fn;
        if (this.editingSn) {
          if (!tab.editFn) {
            this.saving = false;
            this.saveDebug = "ERR: 编辑入口未配置";
            this.notice("编辑功能未配置，请联系管理员", "error");
            return;
          }
          fn = tab.editFn;
        } else {
          fn = tab.saveFn;
        }
        fn(payload).then(res => {
          this.saving = false;
          this.saveDebug = "5. 收到响应 code=" + (res && res.code);
          if (res && res.code == 200) {
            /* 【迭代优化】「保存并继续」：保留表单全部已填内容，仅清编辑态，弹层保持打开，
               可改一处再录下一单（不再重置 addForm，避免清掉刚填的信息）。 */
            if (action === "continue") {
              this.notice(res.msg || "保存成功，可继续添加", "success");
              this.editingSn = "";
              this.saving = false;
              // 不再调用 resetAddFormKeepOpen()：保留 addForm 全部信息，表单不重置
              this.saveDebug = "";
              this.loadAllLists();
              return;
            }
            this.notice(res.msg || "保存成功", "success");
            this.billFormMode = null;
            this.editingSn = "";
            this.loadAllLists();
          } else {
            this.notice((res && res.msg) || "保存失败", "error");
          }
        }).catch(e => {
          this.saving = false;
          this.saveDebug = "ERR: 接口异常 " + (e && e.message ? e.message : String(e));
          this.notice((e && e.msg) || "保存失败（网络/接口异常）", "error");
        });
      } catch (err) {
        this.saving = false;
        const msg = "保存异常：" + (err && err.message ? err.message : String(err));
        this.saveDebug = "ERR: " + msg;
        const t = (typeof this.$toast === "function" ? this.$toast : alert);
        t(msg);
      }
    },

    editContract() {
      this.editForm = {
        sn: this.sn,
        name: this.contract.name || "",
        serial_number: this.contract.serial_number || "",
        sales_amount: this.contract.sales_amount || "",
        room_amount: this.contract.room_amount || "",
        // 订餐/茶歇/其他：与会议室金额同级，后端 ordersSave 已支持写入
        value_added_services_a_amount: this.contract.value_added_services_a_amount || "",
        value_added_services_b_amount: this.contract.value_added_services_b_amount || "",
        other_amount: this.contract.other_amount || "",
        signing_date: this.contract.signing_date || "",
        start_date: this.contract.start_date || "",
        end_date: this.contract.end_date || "",
        contacts: this.contract.contacts || "",
        phone: this.contract.phone || "",
        weixin: this.contract.weixin || "",
        remark: this.contract.remark || ""
      };
      this.editVisible = true;
    },

    submitEdit() {
      if (!this.editForm.name) {
        this.notice("请填写合同名称", "error");
        return;
      }
      this.saving = true;
      saveOrdersData(this.editForm).then(res => {
        this.saving = false;
        if (res && res.code == 200) {
          this.notice(res.msg || "保存成功", "success");
          this.editVisible = false;
          this.fetchHeader();
        } else {
          this.notice((res && res.msg) || "保存失败", "error");
        }
      }).catch(e => {
        this.saving = false;
        console.log(e);
        this.notice("保存失败", "error");
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/contractDetailMixin.js